import makeStyles from "@material-ui/core/styles/makeStyles";

export const useStyles = (theme) =>
    makeStyles(() => ({
        defaultLoading: {
            "& > div": {
                borderColor: `${theme.loadingIndicator.default.color} rgba(0,0,0,0) rgba(0,0,0,0)`,
            },
        },

        primaryLoading: {
            "& > div": {
                borderColor: `${theme.loadingIndicator.primary.color} rgba(0,0,0,0) rgba(0,0,0,0)`,
            },
        },
    }))();
